(() => {
  if (window.lyoHomeMapInitialized) return;

  window.lyoHomeMapInitialized = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lyo-home-map-reveal]');
    if (!trigger) return;

    const section = trigger.closest('[data-lyo-home-map]');
    const card = section?.querySelector('[data-lyo-home-map-card]');
    const iframe = section?.querySelector('[data-lyo-home-map-iframe]');
    if (!section || !card || !iframe) return;

    section.classList.add('lyo-home-map--revealed');
    card.classList.add('is-hidden');
    card.setAttribute('aria-hidden', 'true');
    iframe.removeAttribute('aria-hidden');
    iframe.tabIndex = 0;
    iframe.focus();
  });
})();
